import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	organizationsNavLabel: {
		id: 'fastshift-portal.organizations-flyout.nav-label',
		defaultMessage: 'Organizations',
		description: 'Side navigation label for the organizations menu',
	},
	flyoutTitle: {
		id: 'fastshift-portal.organizations-flyout.title',
		defaultMessage: 'Organizations',
		description: 'Heading of the organizations side navigation flyout',
	},
	closeFlyoutLabel: {
		id: 'fastshift-portal.organizations-flyout.close-label',
		defaultMessage: 'Close organizations menu',
		description: 'Accessible label for the button that closes the organizations flyout',
	},
	viewAllOrganizationsLabel: {
		id: 'fastshift-portal.organizations-flyout.view-all-label',
		defaultMessage: 'View all organizations',
		description: 'Label for the action that opens the full organizations list',
	},
	unknownOrganization: {
		id: 'fastshift-portal.organizations-flyout.unknown-organization',
		defaultMessage: 'Unknown organization',
		description:
			'Shown in place of an organization name when the name could not be resolved by the backend',
	},
	loadingLabel: {
		id: 'fastshift-portal.organizations-flyout.loading-label',
		defaultMessage: 'Loading organizations',
		description: 'Accessible label announced while the organizations flyout is loading',
	},
	emptyDescription: {
		id: 'fastshift-portal.organizations-flyout.empty-description',
		defaultMessage: 'No organizations found.',
		description: 'Supporting text shown when the customer domain has no organizations',
	},
	errorDescription: {
		id: 'fastshift-portal.organizations-flyout.error-description',
		defaultMessage: 'We couldn’t load organizations for this domain.',
		description: 'Message shown when organizations fail to load for the selected domain',
	},
	errorImageAlt: {
		id: 'fastshift-portal.organizations-flyout.error-image-alt',
		defaultMessage: 'Error loading organizations',
		description: 'Alternative text for the illustration shown when organizations fail to load',
	},
});
